export default "__VITE_ASSET__YC4qG$jZ__"